// libs
import React, { useRef } from 'react';
import get from 'lodash/get';

// components
import Product from 'shared/components/Product';

// defs
import { IWidgetItems, IProduct } from 'shared/components/AdPlatformWidgets/types';

// hooks
import { useTrackingObserver } from 'shared/components/AdPlatformWidgets/ImpressionTracking/trackingHooks';

// defs
interface IProductContainerProps {
  width: number;
  item: IWidgetItems | IProduct;
  className?: string;
}

export default function ProductContainer({ width, item, className }: IProductContainerProps) {
  const widgetRef = useRef<HTMLElement>(null);
  const trackingData = get(item, 'trackingData');
  useTrackingObserver({ widgetRef, trackingData });

  return (
    <div ref={widgetRef}>
      <Product className={className} width={width} item={item} />
    </div>
  );
}
